import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { APP_NAME } from 'constants/app.constant';
import useAuth from 'utils/hooks/useAuth';

const LOGO_SRC_PATH = '/img/logo/';

const Logo = (props) => {
  const { type, mode, gutter, className, imgClass, style, logoWidth } = props;
  const { signOut } = useAuth();

  const handleLogoClick = (e) => {
    e.preventDefault();
    signOut();
  };

  return (
    <div
      className={classNames('logo', className, gutter)}
      style={{
        ...style,
        ...{ width: logoWidth },
      }}
    >
      <a href="/" onClick={handleLogoClick}>
        <img
          className={imgClass}
          src={`${LOGO_SRC_PATH}logo-${mode}-${type}.png`}
          alt={`${APP_NAME} logo`}
        />
      </a>
    </div>
  );
};

Logo.defaultProps = {
  mode: 'light',
  type: 'full',
  logoWidth: 'auto',
};

Logo.propTypes = {
  mode: PropTypes.oneOf(['light', 'dark']),
  type: PropTypes.oneOf(['full', 'streamline']),
  gutter: PropTypes.string,
  imgClass: PropTypes.string,
  logoWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Logo;
